import { createRouter, createWebHistory } from 'vue-router'
import { useLoginStore } from '@/pinia'
import { useToast } from '@/composables/useToast'
import indexVue from '../views/indexPage.vue'
import adminVideoVue from '@/views/admin_video.vue'
import loginVue from "@/views/loginPage.vue";
import recordPage from "@/views/recordPage.vue";
import admin_meeting from "@/views/admin_meeting.vue";
import apiKey from "@/views/admin_apiKey.vue";
import detailRecord  from "@/views/detailRecord.vue";
import admin_ageSession from "@/views/admin_ageSession.vue";
import admin_liveManagement from '@/views/admin_liveManagement.vue';
import admin_comCode from "@/views/admin_comCode.vue";
import admin_log from "@/views/admin_log.vue";
import admin_user from "@/views/admin_user.vue";
import newStatistics from "@/views/admin_statisticsPage_new.vue";
const routes = [
  {
    path: '/',
    name: 'indexPage',
    component: indexVue,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/video',
    name: 'videoManagement',
    component: adminVideoVue,
    meta: { requiresAuth: true, roles: ['ADMIN', 'EDITOR'] }
  },
  {
    path : "/login",
    name: 'loginPage',
    component: loginVue,
    meta: { requiresAuth: false }
  },
  {
    path: "/record",
    name: "recordVideo",
    component: recordPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/meeting',
    name: 'meetingManagement',
    component: admin_meeting,
    meta: { requiresAuth: true, roles: ['ADMIN', 'EDITOR'] }
  },
  {
    path: '/admin/apikey',
    name: 'apiKeyManagement',
    component: apiKey,
    meta: { requiresAuth: true, roles: ['ADMIN'] }
  },
  {
    path: "/detail/record/:meetingId",
    name: "detailRecord",
    component: detailRecord,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path:"/admin/ageSession",
    name: "ageSessionView",
    component:admin_ageSession,
    meta: { requiresAuth: true, roles: ['ADMIN', 'EDITOR'] }
  },
  {
    path: "/admin/liveManagement",
    name: "admin_liveManagement",
    component: admin_liveManagement,
    meta: { requiresAuth: true, roles: ['ADMIN', 'EDITOR'] }
  },
  {
    path: "/admin/comCode",
    name: "admin_comCode",
    component: admin_comCode,
    meta: { requiresAuth: true, roles: ['ADMIN'] }
  },
  {
    path: "/admin/log",
    name: "admin_log",
    component: admin_log,
    meta: { requiresAuth: true, roles: ['ADMIN'] }
  },
  {
    path: "/admin/user",
    name: "admin_user",
    component: admin_user,
    meta: { requiresAuth: true, roles: ['ADMIN'] }
  },
  {
    path: '/admin/statistics',
    name: 'statistics',
    component: newStatistics,
    meta: { requiresAuth: true, roles: ['ADMIN'] }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 전역 네비게이션 가드
router.beforeEach((to, from, next) => {
  const loginStore = useLoginStore()
  const toast = useToast()

  // 인증이 필요한 페이지인지 확인
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  // 로그인 상태 확인
  const isAuthenticated = loginStore.jwtToken != null

  // 로그인 페이지로 가는 경우
  if (to.path === '/login') {
    // 이미 로그인되어 있으면 홈으로 리다이렉트
    if (isAuthenticated) {
      return next('/')
    }
    return next()
  }

  // 인증이 필요한 페이지인데 로그인되지 않은 경우
  if (requiresAuth && !isAuthenticated) {
    console.warn('Authentication required, redirecting to login')
    return next('/login')
  }

  // 특정 권한이 필요한 페이지인지 확인
  const requiredRoles = to.meta.roles
  if (requiredRoles && requiredRoles.length > 0) {
    // 사용자가 필요한 권한을 가지고 있는지 확인
    const userRole = loginStore.loginInfo?.role
    const hasPermission = requiredRoles.includes(userRole)

    if (!hasPermission) {
      console.warn(`Access denied. Required roles: ${requiredRoles.join(', ')}. User role: ${userRole}`)
      toast.warning('이 페이지에 접근할 권한이 없습니다.')

      // 이전 페이지로 돌아가거나 홈으로 이동
      if (from.path && from.path !== '/login') {
        return next(false) // 네비게이션 취소
      } else {
        return next('/') // 홈으로 이동
      }
    }
  }

  // 모든 검증 통과
  next()
})

export default router
